package ui.location

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import common.frontend.api.Io
import common.frontend.api.canLocationAdd
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.navTo_LocationUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.findRoot
import tools.printStackTraceInDebug
import ui.location.detail.LocationArgs
import ui.snackBarStateGlobal

@VM
class LocationListingVM : NavigationViewModel() {

    private lateinit var scopeUi: LocationListingScope

    var state by mutableDataState<LocationListingScope.Wrapper>()
        private set

    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        class New(val item: Io.ListingLocation.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: LocationListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is New -> vm.newLocation(act.item)
                        }
                    }
                }
            }
        }
    }

    fun init(scopeUi: LocationListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                val data = if (scopeUi.args.showAll) Repository.api.location.listingAll()
                else Repository.api.location.listing(scopeUi.args.companyId)

                state = DataState.Result(
                    LocationListingScope.Wrapper(
                        canAdd = scopeUi.login.canLocationAdd(scopeUi.args.companyId),
                        listing = data
                    )
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    private fun newLocation(item: Io.ListingLocation.Item) {
        scope.launch {
            runCatching {
                val new = Repository.api.location.add(scopeUi.args.companyId, item)
                state.entry?.add(0, new)
                scopeUi.nav.findRoot().navTo_LocationUI(
                    LocationArgs(
                        companyId = scopeUi.args.companyId,
                        locationId = new.id
                    )
                )
                scopeUi.vmGlobal.reloadCompanyWithLocation(scopeUi.login)
            }.onFailure {
                it.printStackTraceInDebug()
                snackBarStateGlobal.showSnackbar(
                    it.message!!,
                    withDismissAction = true
                )
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
